module.exports = __webpack_public_path__ + "static/media/chevron-forward-outline.9e301916.svg";